module.exports = __webpack_public_path__ + "static/media/add_photo_alternate.942dfbf1.svg";